import { render, staticRenderFns } from "./TrainingRecordNew.vue?vue&type=template&id=2154c2d2"
import script from "./TrainingRecordNew.vue?vue&type=script&lang=js"
export * from "./TrainingRecordNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports